import { render, staticRenderFns } from "./searchSet.vue?vue&type=template&id=0a64ff66&scoped=true&"
import script from "./searchSet.vue?vue&type=script&lang=js&"
export * from "./searchSet.vue?vue&type=script&lang=js&"
import style0 from "./searchSet.vue?vue&type=style&index=0&id=0a64ff66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64ff66",
  null
  
)

export default component.exports